import * as PropTypes from "prop-types";
import {connect} from 'react-redux'
import {utils, Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import OrderStepRow from "../../../components/OrderStepRow";
import CustomerPage from "../CustomerPage";
import * as opravneniActions from "../../../actions/opravneniActions";
import * as objednavkaActions from "../../../actions/objednavkaActions";
import './OrderPage.scss';

/**
 * Wrapper pro stránky procesu objednávky zákazníka.
 * Zobrazuje řádku s jednotlivými kroky objednávky.
 */
class OrderPage extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired, // název stránky v záhlaví, např. Úvodní obrazovka
        subtitle: PropTypes.string, // název podstránky v záhlaví, např. Nová objednávka
        currentStep: PropTypes.number, // pořadí kroku v objednávce ve kterém se uživatel právě nachází
        children: PropTypes.element, // samotný obsah stránky (pod pruhem s kroky objednávky)
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {loggedInUser} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            this.props.dispatch(objednavkaActions.fetchObjednavkaLastFinishedStep(loggedInUser.data.id));
        }
    };

    render() {
        const {loggedInUser, currentStep, children, lastSavedFinishedStep, ...other} = this.props;

        if (!loggedInUser.fetched || loggedInUser.isFetching || !lastSavedFinishedStep.fetched || lastSavedFinishedStep.isFetching) {
            return <Loader/>;
        }

        return <div className="order-page w-100 h-100">
            <CustomerPage {...other}>
                <OrderStepRow currentStep={currentStep} lastStep={lastSavedFinishedStep.data} />
                {children}
            </CustomerPage>
        </div>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        lastSavedFinishedStep: utils.storeFromArea(state, objednavkaActions.LAST_SAVED_FINISHED_STEP_AREA),
    }
}

export default connect(mapStateToProps)(OrderPage);

